"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _ScheduledReportsTableComponent = _interopRequireDefault(require("./ScheduledReportsTableComponent"));
var _reportActions = require("../../../redux/actions/reportActions");
var _reportSelectors = require("../../../redux/selectors/reportSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var reports = (0, _reportSelectors.cancelableScheduledReportsSelector)(state);
  var isLoading = state.report.isLoading;
  return {
    reports: reports,
    isLoading: isLoading
  };
};
var mapDispathToProps = {
  cancelReport: _reportActions.cancelReport
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispathToProps)(_ScheduledReportsTableComponent["default"]);